module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAYUlEQVRYCcXBAQEAAACCoPo/2nwRFOWoKEdFOSrKUVGOinJUlKOiHBXlqChHRTkqylFRjopyVJSjohwV5agoR0U5KspRUY6KclSUo6IcFeWoKEdFOSrKUVGOinJUlKOiHA0xTH+hV6nqxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/white.png
// module id = 253
// module chunks = 0